module.exports = __webpack_public_path__ + "img/1704.19802a29.gif";